<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("keyLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("titleLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("statusLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("userLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("beneficiariesFilterCardType") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("searchByCompanyName") }}</strong>
          </td>          
          <td  valign="middle">
            <strong>{{ $t("beneficiariesTableNameAndSurname") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("beneficiariesTableCNP") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("lastFourPAN") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("descriptionLabel") }}</strong>
          </td>
          <td cvalign="middle">
            <!-- <strong>{{ $t("valueLabel") }}</strong> -->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.complaints === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(complaint, index) in complaints">
          <tr
            :key="index"
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            <td valign="middle">
              <a
                class="detailsOrderMobile priority-show-6 display-inline-block"
                @click="getComplaintDetails(complaint)"
              >
                <font-awesome-icon
                  icon="minus-circle"
                  v-if="
                    detailsMobile && complaint === complaintSelectedMobile
                  "
                />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <a :href="'https://upromania.atlassian.net/browse/' + complaint.key" target="_blank" > {{ complaint.key }} </a>
            </td>
            <td valign="middle">
              {{ complaint.title }}
            </td>
            <td valign="middle">
              {{ complaint.status }}
            </td>
            <td valign="middle">
              {{ complaint.assignee }}
            </td>
            <td valign="priority-1">
              {{ complaint.user_data ? complaint.user_data.card.type :"" }}
            </td>
            <td valign="middle" class="priority-1">
                {{ complaint.user_data ?  complaint.user_data.employer.name : ""}}
            </td>
            <td valign="middle" class="priority-1">
               {{ complaint.user_data ? complaint.user_data.first_name + " " +   complaint.user_data.last_name : ""}}
            </td>
            <td valign="middle" class="priority-1 culoare-12">
                {{ complaint.user_data ? complaint.user_data.cnp : "" }}
            </td>            
            <td valign="middle" class="priority-1">
                {{ complaint.user_data ? complaint.user_data.card.card_last_digits : "" }}
            </td>
            
            <td valign="middle" class="priority-4 overflow max-width-230">
              {{complaint.description.substring(0,100)  }}
            </td>
            <td valign="middle">
                  <a
                    class="see-more cursor-pointer"
                    @click="getComplaintDetails(complaint)"
                  >
                    <font-awesome-icon
                      icon="arrow-alt-circle-right"
                      size="2x"
                    />
                  </a>
                </td>
          </tr>
          <tr
            :key="index + complaints.length"
            class="child"
            :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && complaint === complaintSelectedMobile"
          >
            <td colspan="12">
              <p class="priority-show-1">
                <strong>{{ $t("keyLabel") }} : &nbsp;&nbsp;</strong>
                <span>              
                  <a :href="'https://upromania.atlassian.net/browse/' + complaint.key" target="_blank" > {{ complaint.key }} </a>
              </span>
              </p>
              <p class="priority-show-1">
                <strong>{{ $t("titleLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.title }}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("statusLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.status }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("userLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.assignee }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesFilterCardType") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.card.type : "" }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("searchByCompanyName") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.employer.name : ""}}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesTableNameAndSurname") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.first_name + " " +   complaint.user_data.last_name : ""}}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ complaint.user_data ? complaint.user_data.cnp : ""}}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("lastFourPAN") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ?  complaint.user_data.card.card_last_digits: "" }}</span>
              </p>
              <p class="priority-show-6 overflow max-width-230">
                <strong>{{ $t("descriptionLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.description.substring(0,100) }}</span>
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div id="modal_popup_details" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_details', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.complaintDetails" >
          <p >
                <strong>{{ $t("titleLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.title }}</span>
              </p>
              <p >
                <strong>{{ $t("statusLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.status }} </span>
              </p>
                            <p >
                <strong>{{ $t("keyLabel") }} : &nbsp;&nbsp;</strong>
                <span>              <a :href="'https://upromania.atlassian.net/browse/' + complaintDetails.key" target="_blank"> {{ complaintDetails.key }} </a>
 </span>
              </p>
              <p >
                <strong>{{ $t("beneficiariesFilterCardType") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.card.type : "" }} </span>
              </p>
              <p >
                <strong>{{ $t("beneficiariesFilterCardStatus") }} : &nbsp;&nbsp;</strong>
                <span> {{ complaintDetails.user_data ? $t('cardStatus_' + complaintDetails.user_data.card.status) : "" }}</span>
              </p>
              <p >
                <strong>{{ $t("searchByCompanyName") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.employer.name : ""}}</span>
              </p>
              <p >
                <strong>{{ $t("codallLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.employer.codhd : "" }}</span>
              </p>
              <p >
                <strong>{{ $t("beneficiariesTableNameAndSurname") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.first_name + " " +   complaintDetails.user_data.last_name : ""}}</span>
              </p>
              <p >
                <strong>{{ $t("beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ complaintDetails.user_data ? complaintDetails.user_data.cnp : ""}}</span>
              </p>
              <p >
                <strong>{{ $t("soldLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.card.balance: "" }}</span>
              </p>
              <p >
                <strong>{{ $t("lastFourPAN") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ?  complaintDetails.user_data.card.card_last_digits: "" }}</span>
              </p>
                            <p >
                <strong>{{ $t("phoneJiraLabel") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12">{{ complaintDetails.user_data ? complaintDetails.user_data.phone: "" }}</span>
              </p>
                            <p >
                <strong>{{ $t("cardidLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.user_data ? complaintDetails.user_data.card.card_id: "" }}</span>
              </p>
                                          <p >
                <strong>{{ $t("beneficiariesTableDateCreated") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.created ? complaintDetails.created: "" }}</span>
              </p>
                                          <p >
                <strong>{{ $t("userLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.assignee ? complaintDetails.assignee: "" }}</span>
              </p>              
              <p class='overflow'>
                <strong>{{ $t("descriptionLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaintDetails.description }}</span>
              </p>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
  import moment from "moment";
  import Cookies from "js-cookie";
    import httpServiceBenef from "@/http/http-ben-support.js";


  export default {
    name: "CardTransactionTable",
    props: {
      complaints: Array,
      msg: String,
    },
    data() {
      return {
        detailsMobile: false,
        complaintSelectedMobile: null,
        transactionError: null,
        complaintDetails : null,
      };
    },
    methods: {
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      },
      selectTransactionMobile(index) {
        this.complaintSelectedMobile = this.complaints[index];
        this.detailsMobile = !this.detailsMobile;
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      getComplaintDetails(selectedComplaint) {
       this.showModalPopup("modal_popup_loading", true);
               httpServiceBenef.beneficiariesService
          .getComplaintDetails(
            selectedComplaint.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.complaintDetails = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_details", true);
            } else if (response.status == 400 || response.status == 403) {
              this.complaintDetails = null;
            }
          });
      },
    },
    mounted(){
      localStorage.removeItem("selected_beneficiary");
    }
  };
</script>
<style scoped>
#modal_popup_details .modal-popup-content {
  text-align: left !important;
  max-width: 60% !important;
  width: 60%;
}

.invoices-table {
  padding: 1px;
}

.overflow {
      overflow-wrap: break-word;
}

.max-width-230 {
  max-width: 230px;
}

.hover-table tr.trhover:hover a,
.hover-table tr.trhover:hover a:hover {
	color: #fff;
}

</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
